import { AbstractComponent } from "./AbstractComponent";
import { Modal as BsModal } from "bootstrap";

export interface ModalProps extends Partial<BsModal.Options> {
  action: "click" | "touchstart";
  target: string;
  trigger: HTMLElement;
  onShow?: (e?: Event) => void;
  onHide?: (e?: Event) => void;
  onShown?: (e?: Event) => void;
  onHidden?: (e?: Event) => void;
}

export class Modal extends AbstractComponent<ModalProps> {
  private modalEl: HTMLElement | null;
  
  private constructor(props: ModalProps) {
    super(props);
    this.modalEl = document.querySelector(this.props.target);
  }

  protected createContext(): void {
  }

  public getModalElement(): HTMLElement {
    if (this.modalEl === null) throw new Error('ERROR_MODAL_NOT_FOUND')
    return this.modalEl;
  }

  public getModalBodyElement(): HTMLElement {
    if (this.modalEl === null) throw new Error('ERROR_MODAL_NOT_FOUND')
    const modalBody = this.modalEl.querySelector('.modal-body');
    if (modalBody === null) throw new Error('ERROR_MODAL_BODY_NOT_FOUND')
    return modalBody as HTMLElement;
  }

  public getModalTitleElement(): HTMLElement {
    if (this.modalEl === null) throw new Error('ERROR_MODAL_NOT_FOUND')
    const modalTitle = this.modalEl.querySelector('.modal-title');
    if (modalTitle === null) throw new Error('ERROR_MODAL_TITLE_NOT_FOUND')
    return modalTitle as HTMLElement;
  }

  public getModalFooterElement(): HTMLElement {
    if (this.modalEl === null) throw new Error('ERROR_MODAL_NOT_FOUND')
    const modalFooter = this.modalEl.querySelector('.modal-footer');
    if (modalFooter === null) throw new Error('ERROR_MODAL_FOOTER_NOT_FOUND')
    return modalFooter as HTMLElement;
  }

  public getModalCloseButtonElement(): HTMLElement {
    if (this.modalEl === null) throw new Error('ERROR_MODAL_NOT_FOUND')
    const modalCloseButton = this.modalEl.querySelector('[data-bs-dismiss="modal"]');
    if (modalCloseButton === null) throw new Error('ERROR_MODAL_CLOSE_BUTTON_NOT_FOUND')
    return modalCloseButton as HTMLElement;
  }

  public render(): void {
    if(this.modalEl !== null ) {
      const modal = new BsModal(this.modalEl, {  
        backdrop: this.props.backdrop || false,
        keyboard: this.props.keyboard || false,
        focus: this.props.focus || false
      });
      this.modalEl.addEventListener('show.bs.modal', (e) => {
        this.props.onShow && this.props.onShow(e)
      })
      this.modalEl.addEventListener('hide.bs.modal', (e) => {
        this.props.onHide && this.props.onHide(e)
      })
      this.modalEl.addEventListener('shown.bs.modal', (e) => {
        this.props.onShown && this.props.onShown(e)
      })
      this.modalEl.addEventListener('hidden.bs.modal', (e) => {
        this.props.onHidden && this.props.onHidden(e)
      })
      this.props.trigger.addEventListener(this.props.action, e => {
        e.preventDefault()
        modal.show()
      })
      this.getModalCloseButtonElement().addEventListener(this.props.action, e => {
        e.preventDefault()
        modal.hide()
      })
    }
  }

  public static create(props: ModalProps): Modal {
    return new Modal(props);
  }
}

